import MatomoMessage from '@/matomo/message/MatomoMessage';
import {MatomoActions} from '@/matomo/MatomoActions';

export default class MatomoSearchMessage {
  private message = new MatomoMessage([MatomoActions.search]);
  private numberOfElementsInSearchResult = 0;
  private query = '';

  private constructor(query: string, numberOfElementsInSearchResult: number) {
    this.numberOfElementsInSearchResult = numberOfElementsInSearchResult;
    this.query = query;
  }

  public static from(query: string, numberOfElementsInSearchResult: number): MatomoSearchMessage {
    return new MatomoSearchMessage(query, numberOfElementsInSearchResult);
  }

  public publish() {
    this.message.with(this.query)
        .with(false) // category
        .with(this.numberOfElementsInSearchResult)
        .publish();
  }
}
